module.exports = __webpack_public_path__ + "img/icon_WaterSign_upcoming.de23ea39.png";